import { render } from "./AddBebanOperasional.vue?vue&type=template&id=a5178e5c"
import script from "./AddBebanOperasional.vue?vue&type=script&lang=js"
export * from "./AddBebanOperasional.vue?vue&type=script&lang=js"

import "./AddBebanOperasional.vue?vue&type=style&index=0&id=a5178e5c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__